import { createContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getCachedData, setCachedData } from "./Global";



export const LanguageContext = createContext()



export const getSavedLanguage = () => {
    const lang = getCachedData("selected_language",false)

    return lang ? lang : "en"
}

export default function LanguageSelector({ children }) {
    const { i18n } = useTranslation()
    const [language, setlanguageState] = useState("en")




    const setLanguage = (lang) => {
        if (lang != i18n.language) {
            i18n.changeLanguage(lang)
        }


        setCachedData("selected_language",lang,false)
        setlanguageState(lang)
    }

    useEffect(() => {
        if (!i18n.isInitialized) {
            return
        }

        setLanguage(getSavedLanguage())
    }, [i18n])

    return (
        <LanguageContext.Provider value={{ language, setLanguage }}>
            {children}
        </LanguageContext.Provider>
    )
}